module.exports = __webpack_public_path__ + "img/robur_yellow.e98f160b.jpg";